import { Component, ViewChild, ElementRef, OnInit, OnDestroy, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  CreateProductActions,
  CreateUserAccountActions,
  DocumentSignatureActions,
  TreActions,
  UiActions
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import {
  RequestCreateUserAccount,
  RequestCreateProduct,
  RequestDocumentSignature,
  RequestTre
} from 'src/app/shared/interfaces';
import { LoadingService } from '../../../services/loading.service';
import { EnumService } from '../../../services/enum.service';
import { RedirectService } from 'src/app/services/redirect.service';
import { AccountFormatService } from 'src/app/services/account-format.service';
import { ApiResponseStatus, StepsClientTypes, StepsNotClientTypes } from '../../../shared/enums';
import { ContextService } from 'src/app/services/context.service';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { environment } from 'src/environments/environment';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { DataClientService } from 'src/app/services/data-client.service';
import { SessionService } from 'src/app/services/session.service';
import { FlagrService } from 'src/app/services/flagr/flagr.service';
import { VuSetDataService } from 'vu-second-factor';

@Component({
  selector: 'app-create-product-joint',
  templateUrl: './create-product-joint.component.html',
  styleUrls: ['../../../global.scss', './create-product-joint.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateProductJointComponent implements OnInit, OnDestroy, AfterViewInit {
  public countFingerPrintFail = 0;
  public fingerprint: any;
  authProvider: string;
  staticAssetsUrl = environment.staticScripts.staticAssets;

  private transaccionIdVU: string;
  public showVU = false;
  public typeFactorVU: string;

  mode = environment.mode;
  canCreateProduct: boolean;

  privateMode = false;
  dataService: DataNotClientService | DataClientService;
  treSubscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.tre)
  );

  documentSignatureSuscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.documentSignature)
  );

  createUserAccountSuscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.createUserAccount)
  );

  createProductSubscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.createProduct)
  );

  @ViewChild('vuInput', { static: false })
  vuDomSelector;

  @ViewChild('modalFailFingerprint', { static: false })
  modalFailFingerprint: ElementRef<HTMLDialogElement>;

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    private dataClientService: DataClientService,
    private dataDogService: DatadogService,
    private redirectService: RedirectService,
    private enumService: EnumService,
    private contextService: ContextService,
    public accountFormatService: AccountFormatService,
    public loadingService: LoadingService,
    private sessionService: SessionService,
    private VU: VuSetDataService
  ) {
    this.setService();
  }
  // Flujos privados solo consumen TRE y createProduct
  treSubscription = this.treSubscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      this.dataDogService.addCustomError(error, 'ABR4 authentication error joint', environment.mode, { channel: 'not client' });
      this.actionCleanStateAndRedirect(TreActions);
    }
    if (response) {
      this.store.dispatch(TreActions.cleanState());
      if (response.client.operationState.code === ApiResponseStatus.OK && response.joint.operationState.code === ApiResponseStatus.OK) {
        if (this.privateMode) {
          this.callCreateUserAccount();
        } else {
          this.dataDogService.addCustomEvent('Authenticated ABR4 joint', environment.mode, { channel: 'not client' });
          this.callDocumentSignature();
        }
      } else if (response.client.operationState.code === ApiResponseStatus.FAIL || response.joint.operationState.code === ApiResponseStatus.FAIL) {
        const nextStep = this.privateMode ? StepsClientTypes.STEP_NO_OFFER : StepsNotClientTypes.STEP_SUCURSAL_DERIVATION;
        this.store.dispatch(UiActions.Navigate({ step: nextStep }));
      }
    }
  });

  documentSignatureSuscription = this.documentSignatureSuscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      this.dataDogService.addCustomError(error, 'Sign document error joint', environment.mode, { channel: 'not client' });
      this.redirectService.setErrorMsg('Hemos tenido un problema con la firma digital de tus documentos. Vuelve a intentar en un momento');
      this.actionCleanStateAndRedirect(DocumentSignatureActions);
    }
    if (response) {
      this.store.dispatch(DocumentSignatureActions.cleanState());
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.dataDogService.addCustomEvent('Document Signature Joint', environment.mode, { channel: 'not client' });
        this.callCreateUserAccount();
      } else {
        this.redirectService.setErrorMsg('Hemos tenido un problema con la firma digital de tus documentos. Vuelve a intentar en un momento');
        this.actionCleanStateAndRedirect(DocumentSignatureActions);
      }
    }
  });

  createUserAccountSuscription = this.createUserAccountSuscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      this.dataDogService.addCustomError(error, 'Client create error in joint', environment.mode, { channel: this.privateMode ? 'client' : 'not client' });
      this.actionCleanStateAndRedirect(CreateUserAccountActions);
    }
    if (response) {
      // TODO -> Check creacion de cuenta responde solo para cliente o tambien para mancomunado (puede que haya que agregar ambos al if)
      if (response.client?.operationState?.code === ApiResponseStatus.OK || response.joint?.operationState?.code === ApiResponseStatus.OK) {
        this.dataDogService.addCustomEvent('Client created in joint', environment.mode, { channel: this.privateMode ? 'client' : 'not client' });
        this.store.dispatch(CreateUserAccountActions.cleanState());
        this.callCreateProduct();
      } else {
        this.actionCleanStateAndRedirect(CreateUserAccountActions);
      }
    }
  });

  createProductSubscription = this.createProductSubscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      this.dataDogService.addCustomError(error, 'Account create error', environment.mode, { channel: this.privateMode ? 'client' : 'not client' });
      this.actionCleanStateAndRedirect(CreateProductActions);
    }
    if (response) {
      // TODO -> Check creacion de producto responde solo para cliente o tambien para mancomunado (puede que haya que agregar ambos al if)
      // mismo tema para numeros de cuenta y CCI
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.dataDogService.addCustomEvent('Account created', environment.mode, { channel: this.privateMode ? 'client' : 'not client' });
        if (this.privateMode || this.mode === 'WEB-PF') {
          this.dataService.setAccountNumber(response.client.data.identificadorProducto);
          this.dataService.setCCI(response.client.data.CCI);
        }
        this.store.dispatch(CreateProductActions.cleanState());
        const nextStep = this.privateMode ? StepsClientTypes.SUCCESS_PROCESS : StepsNotClientTypes.SUCCESS_PROCESS;
        return this.store.dispatch(UiActions.Navigate({ step: nextStep }));
      }
    }
  });

  ngOnInit() {
    if (this.sessionService.isCallCenter === '0') {
      this.callTre();
      // WEB-PF o PF si soy CE voy por soft token
    } else if (this.contextService.isPrivateOmni2()) {
      if (this.dataService.jointIsForeign()) {
        console.log('call VU omni 2 privado');
        this.callVU();
      }  else {
        console.log('No soy CE, Puedo crear producto?: ', !this.dataService.getCanCreateProduct());
        if (!this.dataService.getCanCreateProduct()) {
          this.store.dispatch(TagPage({text: 'validación-huella-mancomunado'}));
          this.callFingerPrint();
        }
      }
    } else {
      if (!this.dataService.getCanCreateProduct()) {
        if (!this.dataNotClientService.getJointThroughFingerprint() && !this.dataNotClientService.jointIsForeign()) {
          this.store.dispatch(TagPage({text: 'validación-huella-mancomunado'}));
          this.callFingerPrint();
        }
      }
    }
  }

  ngAfterViewInit() {
    if (this.contextService.isPrivateOmni1()) {
      this.handleWhiteContainer('block');
    } else if (this.contextService.isPublicOmni1()) {
      this.handleWhiteContainer('none');
    }
  }

  // Metodo para limpiar el estado luego de un error de servicio.
  actionCleanStateAndRedirect(action) {
    const nextRedirect = this.privateMode ? StepsClientTypes.STEP_CREATE_PRODUCT : StepsNotClientTypes.STEP_PUBLIC_LANDING;
    this.redirectService.setRedirect(nextRedirect);
    this.store.dispatch(action.cleanState());
    const nextStep = this.privateMode ? StepsClientTypes.STEP_SERVICE_ERROR : StepsNotClientTypes.STEP_SERVICE_ERROR;
    return this.store.dispatch(UiActions.Navigate({ step: nextStep }));
  }

  // Metodo para ocultar o mostrar el contenedor blanco - recordar solo usar 'none' o 'block'
  handleWhiteContainer(canShow: string) {
    const inputElement = document.getElementById('white-container');
    inputElement.style.display = canShow;
  }

  continue() {
    this.loadingService.loading = true;
    // Flujo por omni 2 sitio publico - WEB-PF
    this.callCreateUserAccount();
  }

  callFingerPrint() {
    this.handleWhiteContainer('none');
    this.fingerprint = document.createElement('bfpe-fingerprint-auth');
    const dniNumber = this.dataService.getIndentificationNumberJoint();
    if (!this.privateMode) {
      this.fingerprint.setAttribute('withoutDV', true);
    }
    this.fingerprint.setAttribute('dni', dniNumber);
    this.fingerprint.setAttribute('backdrop', '');
    this.fingerprint.setAttribute('title', 'Validación de huella dactilar mancomunado');
    this.fingerprint.setAttribute('subtitle', 'Resultados');
    document.querySelector('body').appendChild(this.fingerprint);
    this.fingerprint.addEventListener('finished', this.fingerprintFinishedHandler, { once: true });
    const style = document.createElement('style');
    style.innerHTML = `.close {
        display: none !important;
      }
      .wrapper {
        padding-top: 20px !important;
      }`;
    this.fingerprint.shadowRoot.appendChild(style);
  }

  fingerprintFinishedHandler = (event) => {
    if (event.detail) {
      console.log('dato 2 - huellero - flujo mancomunado / Ok');
      const { transactionid, provider } = event.detail;
      this.authProvider = 'ACEPTA';
      if (this.privateMode) {
        this.callCreateUserAccount();
      } else {
        this.dataNotClientService.setFingerprintStatus('OK');
        this.dataNotClientService.setIdentifierFingerprintJoint(transactionid);
        this.callDocumentSignature();
      }
    } else {
      this.countFingerPrintFail++;
      if (this.countFingerPrintFail === 2) {
        this.handleWhiteContainer('block');
        this.dataNotClientService.setFingerprintStatus('FAIL');
        if (this.contextService.isPrivateOmni2()) {
          console.log('Call VU por falla de fingerprint Omni 2 privado - dato 2');
          this.callVU();
        } else if (environment.isMobile) {
          return this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_CLIENT_SOFTOKEN_VU }));
        } else if (this.contextService.isPublicOmni2()) {
          console.log('dato 2 - huellero - flujo mancomunado / Fail');
          this.dataNotClientService.setJointThroughFingerprint(true);
          return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_CONTRACT_SIGNING }));
        }
      } else {
        this.callFingerPrint();
      }
    }
  }

  callDocumentSignature() {
    const request: RequestDocumentSignature = {
      client: {
        identityValidator: this.contextService.isPublicOmni1() ? this.dataNotClientService.getTriSessionID() : this.dataNotClientService.getIdentifierFingerprint()
      },
      joint: {
        identityValidator: this.contextService.isPublicOmni1() ? this.dataNotClientService.getTriSessionID() : this.dataNotClientService.getIdentifierFingerprintJoint()
      }
    };
    this.store.dispatch(DocumentSignatureActions.getDocumentSignature({ request }));
  }

  callCreateProduct() {
    const status = this.dataNotClientService.getFingerprintStatus();
    const request: RequestCreateProduct = {
      client: {
        tipoCuentaDescripcion: this.accountFormatService.getDescription()
      }
    };
    if (this.authProvider) {
      request.client.provider = this.authProvider;
    }
    if (!this.privateMode && status) {
      request.client.fingerprintStatus = status;
    }
    this.store.dispatch(CreateProductActions.getCreateProduct({ request }));
  }

  callTre() {
    const request: RequestTre = {};
    this.store.dispatch(TreActions.getTre({ request }));
  }

  callCreateUserAccount() {
    const request: RequestCreateUserAccount = {};
    this.store.dispatch(CreateUserAccountActions.getCreateUserAccount({ request }));
  }

  callVU() {
    this.handleWhiteContainer('block');
    this.showVU = true;
    this.VU.token = this.sessionService.accessToken;
    this.VU.docType = this.dataClientService.getIdentificationTypeJoint();
    this.VU.docNumber = this.dataClientService.getIndentificationNumberJoint();
    this.loadingService.loading = false;
  }

  action(event) {
    if (event.action === 'OK') {
      this.authProvider = 'VU';
      this.transaccionIdVU = event.transactionId;
      sessionStorage.setItem('auth.provider', 'VU');
      sessionStorage.setItem('auth.transactionId', this.transaccionIdVU);
      this.typeFactorVU = this.vuDomSelector.sms === true ? 'SMS' : 'TOKEN-MOBILE';
      this.showVU = false;
      this.loadingService.loading = true;
      this.handleWhiteContainer('none');
      this.contextService.isExecutiveMode() ? this.callCreateUserAccount() : this.callTre();
    }
  }

  redirectAction(redirect) {
    if (redirect) {
      return this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_NO_OFFER }));
    }
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    // Chequeo que me permite mostrar la opcion de crear cuenta (ver html)
    this.canCreateProduct = this.dataService.getCanCreateProduct();
    console.log('Can create product - dato 2', this.canCreateProduct);
    if (!this.dataService.getJointManualSignature()) {
      const googleAnalytics = {
        is_joint_account: this.dataService.isIsJointAccount(),
        job_information: {
          workActivityType: this.dataService.getWorkActivityTypeJoint() ? this.dataService.getWorkActivityTypeJoint() : 'No informado',
          dateEntryWork: this.dataService.getDateEntryWorkJoint() ? this.dataService.getDateEntryWorkJoint() : 'No informado',
          companyName: this.dataService.getCompanyNameJoint() ? this.dataService.getCompanyNameJoint() : 'No informado',
          rucCompany: this.dataService.getRucCompanyJoint() ? this.dataService.getRucCompanyJoint() : 'No informado',
          profession: this.dataService.getProfessionJoint() ? this.dataService.getProfessionJoint() : 'No informado'
        },
        currency_account_type: this.dataService.getCurrencyType()
      };
      this.store.dispatch(TagPage({text: 'product-create-joint', extras: googleAnalytics}));
    }
  }

  ngOnDestroy() {
    this.createUserAccountSuscription.unsubscribe();
    this.createProductSubscription.unsubscribe();
    this.documentSignatureSuscription.unsubscribe();
    this.treSubscription.unsubscribe();
  }
}
